import React, { Component, useEffect, useState } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { Check, Cross, CameraAdd } from 'sushiweb/Icons';
import {
  Button,
  RadioGroup,
  Textarea,
  Heading,
  SubHeading,
  CheckboxList,
  SearchBox,
  Input,
} from '../../../../UiKit';
import { MultiSelectView } from '../../ReportIssue/Issues/common';
import { grey } from 'sushiweb/tokens/color';
import { getFormData } from '../../../commons/CommonMethods';
import MultiSelectViewV2 from '../../ReportIssue/Issues/common/MultiSelectView/MultiSelectV2';

const reasons = {
  APPROVE: '2',
  REJECT: '3',
};

export default class HandoverReasons extends Component {
  render() {
    const { handoverData } = this.props;
    return (
      <div className='row'>
        {!handoverData ? (
          <Shimmer height='150px' width='100%' />
        ) : (
          <HandoverReasonsComp {...this.props} />
        )}
      </div>
    );
  }
}

class HandoverReasonsComp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReason: null,
      requesteditems: null,
      comment: '',
      is_rpu_applicable: true,
      nestedRadio: null,
      selectedNestedRadioReason: null,
      selectedNestedCheckboxReason: null,
      nestedCheckBox: null,
      // more all this things to backend via generalized form solutions
      customRefundAmount: null,
      showCustomRefundAmount: false,
      customRefundCheckbox: false,
      customRefundError: false,
    };
    this.timerID1 = null;
    this.timerID2 = null;
  }

  componentWillUnmount = () => {
    clearTimeout(this.timerID1);
    clearTimeout(this.timerID2);
  };

  getImages = (images) => {
    return images && images.map((image) => ({ src: image }));
  };

  getReasons = (items) => {
    items.forEach((element) => {
      element['title'] = element.display_text;
      element['id'] = element.tag;
    });

    return items;
  };

  selectDropdown = (selectedReason, item) => {
    this.setState({
      nestedRadio: null,
      nestedCheckBox: null,
    });
    this.timerID1 = setTimeout(() => {
      this.setState({
        selectedReason: selectedReason,
        nestedRadio: item.radio ? item.radio : null,
        nestedCheckBox: item.check_box ? item.check_box : null,
      });
    }, 0);
  };

  selectNestedRadioOption = (selectedNestedReason, item) => {
    this.setState({
      nestedCheckBox: null,
    });

    this.timerID2 = setTimeout(() => {
      this.setState({
        selectedNestedRadioReason: selectedNestedReason,
        nestedCheckBox: item.check_box ? item.check_box : null,
      });
    }, 0);
  };

  selectNestedCheckboxOption = (selectedNestedReason) => {
    this.setState({
      selectedNestedCheckboxReason: selectedNestedReason,
    });
  };

  getSpoiledItems = (items) => {
    const totalItems = Object.keys(items);
    return (
      totalItems &&
      totalItems.map((item) => {
        return {
          text: items[item].name ?? '',
          value: items[item].id,
          max_range: items[item].quantity,
          unit_cost_text: `₹${items[item].cost}`,
          quantity: items[item].quantity,
          inventory: null,
          price: items[item].cost,
        };
      })
    );
  };

  getSpoiledItemsV2 = (items) => {
    const totalItems = Object.keys(items);
    return (
      totalItems &&
      totalItems.map((item) => {
        return {
          text: items[item].name ?? '',
          id: items[item].id,
          max_range: items[item].quantity,
          unit_cost_text: `₹${items[item].cost}`,
          quantity: items[item].quantity,
          max_quantity: items[item].quantity,
          inventory: null,
          price: items[item].cost,
          pickup_enabled: items[item].pickup_enabled,
          pickup_selected: items[item].pickup_selected,
        };
      })
    );
  };

  selectedSpoiledItems = (requesteditems) => {
    this.setState({
      showCustomRefundAmount: false,
      customRefundAmount: null,
      requesteditems: requesteditems,
    });

    // timout hacks: Blinkit 🤝 zomato
    setTimeout(
      () =>
        this.setState({
          showCustomRefundAmount: true,
        }),
      200,
    );
  };

  selectedSpoiledItemsV2 = (requesteditems) => {
    this.setState({
      requesteditems: requesteditems,
    });
  };

  addComment = (event) => {
    this.setState({
      comment: event.target.value,
    });
  };

  sendData = () => {
    const {
      selectedReason,
      requesteditems,
      comment,
      // selectedNestedRadioReason,
      // selectedNestedCheckboxReason,
      // nestedRadio,
      // nestedCheckBox,
      is_rpu_applicable,
      customRefundAmount,
      customRefundError,
    } = this.state;
    const { sendAction, handoverData, selectedBtn } = this.props;
    const { request_id } = handoverData;
    // let nestedRadioData, nestedCheckboxData;
    const selectedBtnType = selectedBtn.type.toLowerCase();

    if (
      (selectedBtnType === 'reject' && !selectedReason) ||
      // (nestedCheckBox && !selectedNestedCheckboxReason) ||
      // (nestedRadio && !selectedNestedRadioReason) ||
      (selectedBtnType === 'approve' && !selectedReason)
    ) {
      return false;
    }

    if (customRefundError) {
      return;
    }

    // if (nestedRadio && nestedRadio.source) {
    //   nestedRadioData = getFormData(nestedRadio, selectedNestedRadioReason);
    // }

    // if (nestedCheckBox && nestedCheckBox.source) {
    //   nestedCheckboxData = getFormData(
    //     nestedCheckBox,
    //     selectedNestedCheckboxReason,
    //   );
    // }

    let data = {};
    if (selectedBtnType === 'approve') {
      data = {
        // ...nestedRadioData,
        // ...nestedCheckboxData,
        reason_slug: selectedReason,
        items:
          requesteditems && Object.keys(requesteditems)?.length
            ? Object.keys(requesteditems).map((item) => {
                if (handoverData?.version === 'v2')
                  return {
                    id: Number(item),
                    quantity: Number(requesteditems[item].quantity),
                    is_pickup: requesteditems[item].pickup,
                    custom_unit: 'percent',
                    custom_value: requesteditems[item].custom_value,
                  };
                else
                  return {
                    id: Number(item),
                    quantity: Number(requesteditems[item]),
                  };
              })
            : null,
        request_id,
        comment,
        is_rpu_applicable,
        status: reasons.APPROVE,
      };

      if (customRefundAmount) {
        data.custom_amount = Number(customRefundAmount);
      }
    } else {
      data = {
        reason_slug: selectedReason,
        status: reasons.REJECT,
        request_id,
      };
    }
    // selectedBtnType === 'reject' && selectedBtn.data ? selectedBtn.data.tag
    sendAction(data);
  };

  render() {
    const { handoverData, goBack, selectedBtn } = this.props;
    const {
      selectedReason,
      nestedRadio,
      nestedCheckBox,
      requesteditems,
      showCustomRefundAmount,
    } = this.state;
    const { tags, request_items, mark_fraud_view } = handoverData;
    const selectedBtnType = selectedBtn.type.toLowerCase();
    let items = tags[selectedBtnType];

    let Icon = Check;
    if (selectedBtnType === 'request_image') {
      Icon = CameraAdd;
    } else if (selectedBtnType === 'reject') {
      Icon = Cross;
    }

    let title =
      selectedBtn && selectedBtnType && selectedBtnType.replace('_', ' ');

    return (
      <div className='col'>
        <div className='box'>
          <p className='titleHeading dark'>{title} reasons </p>
          {items && (
            <SearchBox
              result={this.getReasons(items)}
              onSelect={this.selectDropdown}
              autoFocus={false}
              placeholder={`Select ${title} reasons ...`}
              menuHeight='30rem'
            />
          )}
          {selectedReason && nestedRadio && (
            <div className='col pt10'>
              {nestedRadio.title && <Heading title={nestedRadio.title.text} />}
              {nestedRadio.subtitle && (
                <SubHeading title={nestedRadio.subtitle.text} />
              )}
              <RadioGroup
                items={nestedRadio.source}
                selectOption={this.selectNestedRadioOption}
              />
            </div>
          )}
          {selectedReason && nestedCheckBox && (
            <div className='col pt10'>
              {nestedCheckBox.title && (
                <Heading title={nestedCheckBox.title.text} />
              )}
              {nestedCheckBox.subtitle && (
                <SubHeading title={nestedCheckBox.subtitle.text} />
              )}
              <CheckboxList
                items={nestedCheckBox.source}
                selectOptions={this.selectNestedCheckboxOption}
              />
            </div>
          )}
          {selectedBtnType === 'reject' && mark_fraud_view ? (
            <div className='col pt10'>
              {mark_fraud_view.title && (
                <Heading title={mark_fraud_view.title.text} />
              )}
              {mark_fraud_view.subtitle && (
                <SubHeading title={mark_fraud_view.subtitle.text} />
              )}
            </div>
          ) : null}
          {selectedBtnType === 'approve' ? (
            <React.Fragment>
              {selectedReason && (
                <div css='margin-bottom:0 !important' className='box col '>
                  <p className='titleHeading dark'>
                    Confirm no. of spoiled items
                  </p>

                  {handoverData?.version === 'v2' ? (
                    <MultiSelectViewV2
                      items={this.getSpoiledItemsV2(request_items)}
                      selectItems={this.selectedSpoiledItemsV2}
                      customInputWidth='40%'
                    />
                  ) : (
                    <MultiSelectView
                      items={this.getSpoiledItems(request_items)}
                      selectItems={this.selectedSpoiledItems}
                    />
                  )}
                </div>
              )}

              {handoverData?.version !== 'v2' &&
              showCustomRefundAmount &&
              requesteditems &&
              Object.keys(requesteditems).length ? (
                <CustomRefund
                  customRefundError={this.state.customRefundError}
                  setCustomRefundError={(bool) => {
                    this.setState({
                      customRefundError: bool,
                    });
                  }}
                  checkbox={this.state.customRefundCheckbox}
                  setCheckbox={() => {
                    this.setState({
                      customRefundCheckbox: !this.state.customRefundCheckbox,
                    });
                  }}
                  allRequestedItems={this.getSpoiledItems(request_items)}
                  selectedItems={requesteditems}
                  maxRefundAmount={Number(handoverData.max_refund_amount)}
                  setCustomRefundAmount={(val) => {
                    this.setState({
                      customRefundAmount: val,
                    });
                  }}
                />
              ) : null}

              <div className='pt10'>
                <Textarea
                  showBtn={false}
                  placeholder='Comments (optional)'
                  height='10vh'
                  onChange={this.addComment}
                />
              </div>
              {handoverData?.version !== 'v2' && (
                <div className='checkbox'>
                  <label>
                    <input
                      type='checkbox'
                      checked={this.state.is_rpu_applicable}
                      onChange={(e) =>
                        this.setState({
                          is_rpu_applicable: e.target.checked,
                        })
                      }
                    />
                    <p>
                      <span></span>
                      Can items be picked up?
                    </p>
                  </label>
                </div>
              )}
            </React.Fragment>
          ) : null}
        </div>

        <div className='btns pt10'>
          <div className='iconMarginR'>
            <Button
              title={
                <p style={{ color: selectedBtn.btn_color }}>
                  <span className='iconMarginR'>
                    <Icon size={14} color={selectedBtn.btn_color} />
                  </span>
                  <span>{selectedBtn.btn_text}</span>
                </p>
              }
              size='compressed'
              color={selectedBtn.btn_color}
              outline={true}
              onClick={this.sendData}
            />
          </div>
          <div className='rightBtn'>
            <Button
              title='Go Back'
              size='compressed'
              color={grey.z700}
              onClick={goBack}
            />
          </div>
        </div>
      </div>
    );
  }
}

function CustomRefund({
  maxRefundAmount,
  selectedItems,
  allRequestedItems,
  setCustomRefundAmount,
  checkbox,
  setCheckbox,
  setCustomRefundError,
  customRefundError,
}) {
  const [inputVal, setInputVal] = useState('');
  const inputNoteError = customRefundError ? 'inputNoteError' : '';

  // reset
  useEffect(() => {
    if (!checkbox) {
      setCustomRefundError(false);
      setInputVal('');
      setCustomRefundAmount(null);
    }
  }, [checkbox]);

  // :bigbrain time 🧠
  const totalRefundableAmountForSelectedItems = allRequestedItems
    .filter((i) => Boolean(selectedItems[i.value]))
    .reduce((acc, item) => {
      return acc + Number(item.price) * Number(selectedItems[item.value]);
    }, 0);

  const maxPossibleRefundAmount = Math.min(
    maxRefundAmount,
    totalRefundableAmountForSelectedItems,
  );

  const handleChange = (val) => {
    if (Number(val) > Number(maxPossibleRefundAmount)) {
      setCustomRefundError(true);
      return;
    }

    setCustomRefundError(false);
    setInputVal(val);
    setCustomRefundAmount(val);
  };

  return (
    <div
      css={`
        flex-direction: column;
      `}
    >
      <div
        css={`
          margin-bottom: 0 !important;
        `}
        className='checkbox'
      >
        <label>
          <input type='checkbox' checked={checkbox} onChange={setCheckbox} />
          <p>
            <span></span>
            Refund a custom amount
          </p>
        </label>
      </div>

      {checkbox ? (
        <div
          css={`
            flex-direction: column;
            max-width: 200px;
          `}
          className='inputContainer'
        >
          <Input
            placeholder={'Enter refund Amount'}
            value={inputVal}
            type={'number'}
            onChange={handleChange}
            error={inputNoteError}
            inputLimitError={inputNoteError}
            showMaxLimit={false}
          />
          <p
            css={`
              ${inputNoteError ? 'color: #d02a38' : ''}
            `}
            className={`light note small`}
          >{`Max amount ₹${maxPossibleRefundAmount}`}</p>
        </div>
      ) : null}
    </div>
  );
}
